import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=ed1c5018"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports